/**
 * pages.config.js - Page routing configuration
 * 
 * This file is AUTO-GENERATED. Do not add imports or modify PAGES manually.
 * Pages are auto-registered when you create files in the ./pages/ folder.
 * 
 * THE ONLY EDITABLE VALUE: mainPage
 * This controls which page is the landing page (shown when users visit the app).
 * 
 * Example file structure:
 * 
 *   import HomePage from './pages/HomePage';
 *   import Dashboard from './pages/Dashboard';
 *   import Settings from './pages/Settings';
 *   
 *   export const PAGES = {
 *       "HomePage": HomePage,
 *       "Dashboard": Dashboard,
 *       "Settings": Settings,
 *   }
 *   
 *   export const pagesConfig = {
 *       mainPage: "HomePage",
 *       Pages: PAGES,
 *   };
 * 
 * Example with Layout (wraps all pages):
 *
 *   import Home from './pages/Home';
 *   import Settings from './pages/Settings';
 *   import __Layout from './Layout.jsx';
 *
 *   export const PAGES = {
 *       "Home": Home,
 *       "Settings": Settings,
 *   }
 *
 *   export const pagesConfig = {
 *       mainPage: "Home",
 *       Pages: PAGES,
 *       Layout: __Layout,
 *   };
 *
 * To change the main page from HomePage to Dashboard, use find_replace:
 *   Old: mainPage: "HomePage",
 *   New: mainPage: "Dashboard",
 *
 * The mainPage value must match a key in the PAGES object exactly.
 */
import AdditionalPrepCounsel from './pages/AdditionalPrepCounsel';
import AdditionalPrepSolicitor from './pages/AdditionalPrepSolicitor';
import AdditionalPrepWorksheet from './pages/AdditionalPrepWorksheet';
import AidPlanner from './pages/AidPlanner';
import ClaimCosts from './pages/ClaimCosts';
import Guidelines from './pages/Guidelines';
import IntakeForm from './pages/IntakeForm';
import LegalAidForm from './pages/LegalAidForm';
import MemoPrecedent from './pages/MemoPrecedent';
import VLAReportWorksheet from './pages/VLAReportWorksheet';
import StandAloneGuidelines from './pages/StandAloneGuidelines';
import Inbox from './pages/Inbox';


export const PAGES = {
    "AdditionalPrepCounsel": AdditionalPrepCounsel,
    "AdditionalPrepSolicitor": AdditionalPrepSolicitor,
    "AdditionalPrepWorksheet": AdditionalPrepWorksheet,
    "AidPlanner": AidPlanner,
    "ClaimCosts": ClaimCosts,
    "Guidelines": Guidelines,
    "IntakeForm": IntakeForm,
    "LegalAidForm": LegalAidForm,
    "MemoPrecedent": MemoPrecedent,
    "VLAReportWorksheet": VLAReportWorksheet,
    "StandAloneGuidelines": StandAloneGuidelines,
    "Inbox": Inbox,
}

export const pagesConfig = {
    mainPage: "StandAloneGuidelines",
    Pages: PAGES,
};
